import React from 'react';
import { IconActivity, IconDots, IconEdit, IconPassword, IconTrash } from "@tabler/icons-react";
import { MantineMenu, MantineMenuDropdown, MantineMenuItem, MantineMenuTarget } from "../../../components/mantine/menu";
import { ActionIcon, rem } from '@mantine/core';

const ActionMenu = (props:any) => {
  const  { item, open, openResetPassword, onActivationDeactivation, SetSelectedRows ,OpendeletePopUp }=props
  return(
    <MantineMenu transitionProps={{ transition: 'pop' }} withArrow position="bottom-end" withinPortal>
        <MantineMenuTarget>
            <ActionIcon variant="subtle" color="gray">
                <IconDots style={{ width: rem(16), height: rem(16) }} stroke={1.5} />
            </ActionIcon>
        </MantineMenuTarget>
        <MantineMenuDropdown>
            <MantineMenuItem
                leftSection={<IconEdit style={{ width: rem(16), height: rem(16) }} stroke={1.5} />}
                onClick={() => { open(); SetSelectedRows(item); }}
            >
                Edit
            </MantineMenuItem>
            {item?.userRoleID == 2 && (
                <MantineMenuItem
                    leftSection={<IconActivity style={{ width: rem(16), height: rem(16) }} stroke={1.5} />}
                    onClick={() => { onActivationDeactivation(); SetSelectedRows(item) }}
                >
                    {!item?.isActive ? "Activate" : "Deactivate"} Account
                </MantineMenuItem>
            )}
             <MantineMenuItem
                leftSection={<IconTrash style={{ width: rem(16), height: rem(16) }} stroke={1.5} />}
                onClick={() => { OpendeletePopUp(); SetSelectedRows(item); }}
            >
               Delete
            </MantineMenuItem>
            <MantineMenuItem
                leftSection={<IconPassword style={{ width: rem(16), height: rem(16) }} stroke={1.5} />}
                onClick={() => { openResetPassword(); SetSelectedRows(item) }}
            >
                Reset Password
            </MantineMenuItem>
        </MantineMenuDropdown>
    </MantineMenu>
    );
};

export default ActionMenu;
